import { FC } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { IInformationTypeAccess } from "../../models/informationType";

interface IProps {
  informationTypes: IInformationTypeAccess[];
}

const InformationTypeSelectAll: FC<IProps> = ({ informationTypes }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<{
    informationTypeIds: number[];
  }>();
  const informationTypeIds = values.informationTypeIds ?? [];
  const allSelected =
    informationTypes.length > 0 &&
    informationTypes.every((informationType) =>
      informationTypeIds.includes(informationType.id)
    );

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <input
        id="information-type-select-all"
        type="checkbox"
        checked={allSelected}
        disabled={informationTypes.length === 0}
        style={{ width: "1.5rem", height: "1.5rem" }}
        onChange={() =>
          setFieldValue(
            "informationTypeIds",
            allSelected
              ? []
              : informationTypes.map((informationType) => informationType.id)
          )
        }
      />
      <label
        htmlFor="information-type-select-all"
        style={{ marginLeft: "1rem", fontWeight: "bold" }}
      >
        {allSelected ? t("common.unselectAll") : t("common.selectAll")}
      </label>
    </div>
  );
};

export default InformationTypeSelectAll;
